<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="careHomeReviewForm"
    style="max-width: 600px"
  >
    <slot name="token"></slot>
    <div class="mb-4">
      <div class="form-group form-group--input">
        <label for="email" class="sr-only">Email</label>
        <Field
          tabindex="3"
          id="email"
          name="email"
          placeholder="Your email address *"
          class="form-control fs-16 ph-16 ph-dark-grayish-blue"
          :class="{'is-danger': errors['email'] }"
        />
        <ErrorMessage name="email" class="is-danger" />
      </div>
      <input type="hidden" name="captcha_action" value="care_home_review">
      <transition name="fade">
        <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
      </transition>
      <input type="submit" class="btn btn--green btn--auto-width submit" :value="props.buttonName">
    </div>
  </Form>
</template>

<script setup>

import {reactive, ref} from 'vue'
import {ErrorMessage, Field, Form} from 'vee-validate'
import axios from 'axios'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()

const schema = {
  email: 'required|email',
}

const props = defineProps({
  postUrl: {
    type: String,
    default: '',
  },
  buttonName: {
    type: String,
    default: 'Submit',
  },
})

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('careHomeReviewForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post(props.postUrl, formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}
</script>
